import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ModalDialogService } from '../../modal-dialog/modal-dialog.service';
import { GlobalNotificationInput, GlobalNotificationPopupComponent, GlobalNotificationResult } from './global-notification-popup.component';

@NgModule({
  declarations: [
    GlobalNotificationPopupComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  providers: [
    ModalDialogService<GlobalNotificationResult, GlobalNotificationInput>
  ],
  exports: [
    GlobalNotificationPopupComponent
  ]
})
export class GlobalNotificationPopupModule { }
